export default "__VITE_ASSET__CSzhu59G__"